import { LocalPhone, Email } from '@mui/icons-material'
import classNames from 'classnames'
import { formatPhoneNumber } from 'helpers/phones'
import { Link } from 'ui'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'

import style from './ServiceDetailContacts.module.scss'

type TServiceDetailContacts = {
  phoneNumber: string
  email: string
}
// контакты на детальной странице сц
export function ServiceDetailContacts({
  phoneNumber,
  email,
}: TServiceDetailContacts) {
  const formatPhone = formatPhoneNumber('74996486569')

  return (
    <InformationBlock title='Контакты'>
      {phoneNumber && (
        <div className={style.phone}>
          <Link
            href={`tel:+74996486569`}
            className={style.informationBlockLink}
            data-testid='sc-phone-link'
          >
            <LocalPhone color='primary' />
            {formatPhone}
          </Link>
          {`, доб. ${phoneNumber}`}
        </div>
      )}
      {email && (
        <Link
          href={`mailto:${email}`}
          className={classNames(style.informationBlockLink, style.emailLink)}
          data-testid='sc-email-link'
        >
          <Email color='primary' />
          {email}
        </Link>
      )}
    </InformationBlock>
  )
}
